import axios from '../utils/axios';

export default {
  upload: async (id: string, data: FormData) => (await axios.post(`/company/${id}/item/upload`, data)).data,
  getFiles: async (id: string) => (await axios.get(`/company/${id}/datafiles`)).data
}